/**
 * D12 mark, ember. Drawn bare — the SVG already strokes a 1.5px #3a3430
 * rounded rect. Do not wrap it in another tile.
 */
export function D12Mark({
	size = 36,
	className,
	labelled = true,
}: {
	size?: number;
	className?: string;
	/** Turn off when the wordmark next to the mark already names the brand. */
	labelled?: boolean;
}) {
	return (
		<svg
			viewBox="0 0 64 64"
			width={size}
			height={size}
			fill="none"
			role={labelled ? "img" : undefined}
			aria-label={labelled ? "D12 Labs" : undefined}
			aria-hidden={labelled ? undefined : true}
			className={className}
		>
			<rect
				x="1.25"
				y="1.25"
				width="61.5"
				height="61.5"
				rx="16"
				stroke="#3a3430"
				strokeWidth="1.5"
			/>
			<rect x="15" y="34" width="7" height="17" rx="3.5" fill="#6b615a" />
			<rect x="28.5" y="25" width="7" height="26" rx="3.5" fill="#e8e2da" />
			<rect x="42" y="14" width="7" height="37" rx="3.5" fill="#ef7c26" />
			<circle cx="45.5" cy="8" r="3" fill="#ffa14d" />
		</svg>
	);
}
